import { getNetwork } from '../../utils/getNetwork';
import { API_ROOT } from '../../config';
import { META, ENT, isDuplicateKey } from './mockData';

export const USE_MOCK = true;

const META_ENDPOINT = '/api/budget/arm/meta';
const PERIODS_ENDPOINT = '/api/budget/arm/periods';

export class ApiError extends Error {
  constructor(status, body) {
    super('api_error');
    this.status = status;
    this.body = body;
  }
}

/* --------------------------------- Мета --------------------------------- */
export async function fetchBudgetMeta() {
  if (USE_MOCK) return wait(200).then(() => META);
  const res = await getNetwork().get(API_ROOT + META_ENDPOINT);
  return res.data;
}

/* ------------------------ Перечень периодов года ------------------------ */
export async function fetchBudgetPeriods(side, year) {
  if (USE_MOCK) return wait(250).then(() => ({ periods: mockPeriods(side, year) }));
  const res = await getNetwork().get(API_ROOT + PERIODS_ENDPOINT, {
    params: { side, year },
  });
  const data = res.data || {};
  return { periods: Array.isArray(data.periods) ? data.periods : [] };
}

/* --------------------- Матрица одного периода (view) -------------------- */
export async function fetchBudgetPeriod(side, key) {
  if (USE_MOCK) return wait(200).then(() => ({ rows: mockPeriodRows(side, key) }));
  const res = await getNetwork().get(`${API_ROOT + PERIODS_ENDPOINT}/${encodeURIComponent(key)}`, {
    params: { side },
  });
  const data = res.data || {};
  return { rows: Array.isArray(data.rows) ? data.rows : [] };
}

/* ------------------------------- Создание ------------------------------- */
// payload: { side, year, month, rows: [ { row_id, plan, exec } ] }
export async function createBudgetPeriod(payload) {
  if (USE_MOCK) return mockCreate(payload);
  try {
    const res = await getNetwork().post(API_ROOT + PERIODS_ENDPOINT, payload);
    if (res && res.status === 201) return res.data;
    if (res) throw new ApiError(res.status, res.data);
    throw new ApiError(0, null);
  } catch (e) {
    if (e instanceof ApiError) throw e;
    throw new ApiError((e.response && e.response.status) || 0, e.response && e.response.data);
  }
}

/* --------------------------------- Мок ---------------------------------- */
const pkey = (m, y) => `${m}.${y}`;

function mockTotals(side, key) {
  const v = ENT[side][key];
  if (!v) return null;
  let plan = 0;
  let exec = 0;
  v.forEach(([a, b]) => {
    plan += a;
    exec += b;
  });
  return { plan, exec, pct: plan ? (exec / plan) * 100 : null };
}

// Перечень: только реально введённые месяцы года (не введённые фронт достраивает сам).
function mockPeriods(side, year) {
  const rowsCount = META.rows[side].length;
  const out = [];
  for (let m = 1; m <= 12; m += 1) {
    const key = pkey(m, year);
    const tot = mockTotals(side, key);
    if (!tot) continue;
    out.push({
      month: m,
      key,
      entered: true,
      rows_count: rowsCount,
      plan: tot.plan,
      exec: tot.exec,
      pct: tot.pct,
    });
  }
  return out;
}

// Матрица периода: значения по row_id в порядке справочника.
function mockPeriodRows(side, key) {
  const v = ENT[side][key];
  const rows = META.rows[side];
  if (!v) return [];
  return rows.map((r, i) => ({
    row_id: r.row_id,
    plan: v[i] ? v[i][0] : null,
    exec: v[i] ? v[i][1] : null,
  }));
}

function mockCreate(payload) {
  return wait(350).then(() => {
    const { side, year, month, rows } = payload;
    const key = pkey(month, year);
    if (isDuplicateKey(side, key)) {
      throw new ApiError(409, { error: { code: 'duplicate_period' } }); // АС3
    }
    // Запись в память в порядке справочника по row_id.
    const order = META.rows[side].map((r) => r.row_id);
    const byId = {};
    rows.forEach((r) => {
      byId[r.row_id] = [Number(r.plan), Number(r.exec)];
    });
    ENT[side][key] = order.map((id) => byId[id] || [0, 0]);

    // Поддерживаем список лет с данными (в реальном API это делает /meta на бэке).
    const y = Number(year);
    if (Array.isArray(META.years_with_data) && !META.years_with_data.includes(y)) {
      META.years_with_data = [...META.years_with_data, y].sort((a, b) => a - b);
    }

    return { side, year: y, month: Number(month), key };
  });
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
